import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import {
  QRCode as QRCodeComponent,
  QRCodeComponentProps,
} from "../../components/QRCode";

import { getReferral } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getIsLoadingQR,
  getMerchantId,
  getQR,
  getQRError,
  getWidgetConfigId,
} from "../../reducers/methods";
import { PRODUCT_CHANNELS, QR_CODE_CHANNEL } from "../../constants";
import { extractShopifyParams } from "../../utils/shopify";

interface QRCodeContainerProps extends QRCodeComponentProps {
  getReferral: typeof getReferral;
  error: ReturnType<typeof getQRError>;
  isLoading: ReturnType<typeof getIsLoadingQR>;
  qr: ReturnType<typeof getQR>;
  campaignId: string;
  merchantId: string;
  widgetConfigId: string;
  channel?: string;
}

class QRCode extends React.Component<QRCodeContainerProps> {
  componentDidMount() {
    const customer = get(this.props.data, "customer", {});
    const componentConfig = this.props.config[this.props.configName] || {};
    const channel =
      this.props.channel || (componentConfig as any).channel || QR_CODE_CHANNEL;

    if (customer.email && !this.props.isLoading && isEmpty(this.props.qr)) {
      const productParams = PRODUCT_CHANNELS.includes(channel)
        ? extractShopifyParams(get(this.props, "data.url.current"))
        : {};

      this.props.getReferral({
        channel,
        email: customer.email,
        campaignId: this.props.campaignId,
        merchantId: this.props.merchantId,
        widgetConfigId: this.props.widgetConfigId,
        // Guard against null name values
        name: customer.name || undefined,
        ...productParams,
      });
    }
  }

  render() {
    return <QRCodeComponent {...this.props} qrReferral={this.props.qr} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsLoadingQR(state),
  qr: getQR(state),
  campaignId: getCampaignId(state),
  merchantId: getMerchantId(state),
  widgetConfigId: getWidgetConfigId(state),
  error: getQRError(state),
});

export default connect(mapStateToProp, { getReferral })(QRCode);
